export default "__VITE_ASSET__BtGPm_St__"